import mathScript from "./mathScript" 
export default class stringScript extends mathScript{
    constructor(system){
        super(system);
    }
    //字符串脚本
    //取得制定的ASCII码对应的字符
    AscToChar(string) {
        //ascii:ASCII值，为数值型常量、变量或表达式
        //返回值 类型为字符串
        //str = AscToChar (49) ;
        //str值为"1"
        //str = AscToChar (65) + AscToChar (66) + AscToChar (67) + AscToChar (10) + AscToChar (13);
        //str值将"ABC[LF][CR]", [LF]为换行符,[CR]为回车
        return String.fromCharCode(string);
    }

    //得到字符串变量首字符的ASCII值
    CharToAsc(string) {
        var str = string.substr(0, 1);
        return  str.charCodeAt();
    }

    //将整数转换为字符串
    IntToStr(number,base) {
        //number 为数值型变量或表达式,base 为进制数，整型常量或变量，其取值范围是10,16,8
        if(base == 16 || base == 8){
            var num = parseInt(number);
            var str = num.toString(base);
            return str;
        }
        var str = parseInt(number,base);
        return str.toString();
    }

    //将实型的变量转换成字符串,结果为字符串
    RealToStr(number,m,n) {
        //number 为要转换的实型变量或表达式
        //m 为字符串长度
        //n 为小数位数
        if(n < 0){
            return number.toString();
        }
        var str = number.toFixed(n);
        return str.toString();
    }

    //在字符串中查找匹配的字符串位置
    StrInStr(stringSource, searchFor, startPos) {
        //stringSource 搜索字符串。类型为字符串变量、常量或字符串表达式
        //searchFor 要搜索的字符串。类型为字符串变量、常量或字符串表达式
        //startPos 搜索开始位置的索引,索引从0开始
        var strNumber  = stringSource.indexOf(searchFor);
        if(strNumber > 0){
            return strNumber + startPos;
        }else{
            return strNumber = -1;
        }
    }

    //截取字符串左边的count字符
    StrLeft(string, count) {
        //count 要截取的字符串长度为整型
        return string.substr(0, count);
    }

    //得到字符串长度
    StrLen(string) {
        return string.length;
    }

    //将字符串中的大写字符转换成小写字符
    StrLower(str) {
        return str.toLocaleLowerCase();
    }

    //截取由first开始count个字符组成的字符串
    StrMid(string, first, count) {
        //first 要截取的第一个字符的位置序号，序号从0开始;count 要截取的字符串长度,为整型
        return string.substr(first, count);
    }

    //重复字符串操作
    StrRepeate(str, num) {
        //str 要重复复制的字符串
        //num 重复次数,类型为整型
        var strRp =  '';
        for (var i = 0; i < num; i++) {
            strRp += str;
        }
        return strRp;
    }

    //字符串替换，即替换字符串中的oldStr匹配的字符串为新的字符串newStr
    StrReplace(str, oldStr,newStr) {
        //oldStr 要替换的字符串，newStr 替换字符串
        var reg = new RegExp(oldStr,"g"); //创建正则RegExp对象
        return  str.replace(reg,newStr);
    }

    //截取字符串右边的count个字符
    StrRight(string, count) {
        //count 要截取的字符串长度
        return string.substring(string.length-count);
    }

    //将字符串转换为整型数
    StrToInt(string) {
        return parseInt(string);
    }

    //将字符串按照指定进制转换成整型数
    StrToIntEx(string,base) {
        //base 进制
        return parseInt(string, base);
    }

    //字符串转换为实型数
    StrToReal(string) {
        return parseFloat(string);
    }

    //过滤掉字符串中左边无用的空格
    StrTrimLeft(string) {
        return string.replace(/(^\s*)/g, "");
    }

    //过滤掉字符串中右边无用的空格
    StrTrimRight(string) {
        return string.replace(/(\s*$)/g, "");
    }

    //将字符串中的所有小写字符转换为大写字符
    StrUpper(str) {
        return str.toLocaleUpperCase();
    }
}


// WEBPACK FOOTER //
// ./src/js/script/js/stringScript.js